import React, { useState, useEffect } from "react";
import { formatDatetimeLocal } from "../utils";

export const ExpireAtInput = ({ expireAt, onSave, loading }) => {
  const [val, setVal] = useState(() => formatDatetimeLocal(expireAt));

  useEffect(() => {
    setVal(formatDatetimeLocal(expireAt));
  }, [expireAt]);

  const currentTs = expireAt ? new Date(expireAt).getTime() : 0;
  const selectedTs = val ? new Date(val).getTime() : 0;
  const isChanged = selectedTs > 0 && selectedTs !== currentTs;

  const handleSave = () => {
    if (isChanged && !isNaN(selectedTs)) {
      onSave("expireAt", selectedTs);
    }
  };

  return (
    <div className="flex flex-col gap-1 w-full">
      <label className="text-xs font-semibold text-slate-600">เวลาหมดอายุ</label>
      <div className="flex gap-2 items-center w-full">
        <input
          className="border border-slate-300 w-full h-[38px] px-2.5 font-semibold rounded-md text-sm bg-white text-slate-800 disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          type="datetime-local"
          disabled={loading}
          value={val}
          onChange={(e) => setVal(e.target.value)}
        />
        {isChanged && (
          <button
            type="button"
            disabled={loading}
            onClick={handleSave}
            className="bg-blue hover:opacity-90 text-white font-bold h-[38px] px-3 rounded-md text-sm transition-all whitespace-nowrap shadow-xs disabled:opacity-50"
          >
            บันทึก
          </button>
        )}
      </div>
    </div>
  );
};
